import React, { Component } from 'react';
import { Form, Slider, Button, Row, Col, Upload, message, Icon } from 'antd';
import { FormItemLayout, ConfigFormDecorator } from '../../tools';
import { HotZoneEditor } from '../../../../components';
import './index.less';

const FormItem = Form.Item;

const getImageSize = (imageUrl: string, callback: Function) => {
    const img = new Image();
    img.onload = function() {
        const width = img.width;
        const height = img.height;
        callback(null, width, height);
    };
    img.onerror = function() {
        callback('Failed to load image', null, null);
    };
    img.src = imageUrl;
};

const wrapName = 'entry';
const result = 'hotZoneList';

type beforeUploadType = (file: any) => Promise<void>;
class Index extends Component<any> {
    state = { visible: false, fileList: [] };

    componentDidMount() {
        const { backPic } = this.props.value;
        const fileList = backPic
            ? [{ uid: '-1', name: 'xxx.png', status: 'done', url: this.props.value.backPic }]
            : [];
        this.setState({ fileList });
    }

    // handleUploadBack = (path: string) => {
    //     const { onChange, value } = this.props;
    //     getImageSize(path, (err: any, width: any, height: any) => {
    //         if (!err) {
    //             onChange({
    //                 ...value,
    //                 backPic: `${path}?width=${width}&height=${height}`,
    //             });
    //         }
    //     });
    // };

    handleEditHotZone = (flag: boolean) => {
        if (flag) {
            const { backPic } = this.props.value;
            this.setState({ visible: !!backPic && backPic.includes('https') });
        } else {
            this.setState({ visible: false });
        }
    };

    handleBeforeUpload: beforeUploadType = (file) => {
        return new Promise((resolve, reject) => {
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isLt2M) {
                message.error(`图片${file.name}超出限制，最大上传 2MB 图片`);
                this.setState({ fileList: [] });
                reject();
            } else {
                resolve(file);
            }
        });
    };

    handleChange = (e: any) => {
        this.setState({ fileList: e.fileList }, () => {
            const cur = e.fileList[0] || {};
            const { onChange, value } = this.props;

            if (cur?.response?.path) {
                getImageSize(cur?.response?.path, (err: any, width: any, height: any) => {
                    if (!err) {
                        onChange({
                            ...value,
                            backPic: `${cur?.response?.path}?width=${width}&height=${height}`,
                        });
                    } else {
                        onChange({ ...value, backPic: '' });
                    }
                });
            } else {
                onChange({ ...value, backPic: '' });
            }
        });
    };

    render() {
        const formItemLayout = FormItemLayout;
        const { visible, fileList } = this.state;
        const {
            form: { getFieldDecorator },
            value,
            // sourceRoot,
            uploadAction,
            linkTypeMode,
            onChange,
        } = this.props;
        const { backPic, hotZoneList } = value;
        // console.log('%c hot-zone uploadAction', 'background:pink;', this.state.fileList);

        const uploadButton = (
            <div>
                <Icon type="plus" />
                <div className="ant-upload-text">上传</div>
            </div>
        );
        return (
            <div className="hot-zone">
                <Form>
                    <FormItem {...formItemLayout} label={'页面边距'}>
                        {getFieldDecorator('pageMargin', { initialValue: 0 })(<Slider />)}
                    </FormItem>

                    <FormItem {...formItemLayout} label="图片圆角">
                        {getFieldDecorator('imageCir', { initialValue: 0 })(<Slider />)}
                    </FormItem>

                    <FormItem {...formItemLayout} label={'图片'}>
                        {getFieldDecorator('backPic', { rules: [{ required: true }] })(
                            <>
                                <Row
                                    className="entry-item"
                                    type="flex"
                                    style={{ backgroundColor: '#FFFFFF', border: 'none' }}
                                >
                                    <Col className="entry-item-image" span={6}>
                                        {/* <UploadPicture
                                            value={get(value, 'backPic', '')}
                                            sourceRoot={sourceRoot}
                                            onChange={this.handleUploadBack}
                                            uploadAction={uploadAction}
                                        /> */}
                                        <Upload
                                            accept="image/*"
                                            name="fileName"
                                            action={uploadAction}
                                            listType="picture-card"
                                            fileList={fileList}
                                            beforeUpload={this.handleBeforeUpload}
                                            onChange={this.handleChange}
                                        >
                                            {fileList.length >= 1 ? null : uploadButton}
                                        </Upload>
                                    </Col>
                                    <Col
                                        span={18}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginTop: '-20px',
                                        }}
                                    >
                                        支持jpg/png/gif 格式，大小不超过2MB
                                    </Col>
                                </Row>
                            </>
                        )}
                    </FormItem>

                    <FormItem {...formItemLayout} label="编辑热区">
                        <Button onClick={() => this.handleEditHotZone(true)}>添加热区</Button>
                        <div style={{ color: '#F2A861' }}>当前创建了{hotZoneList.length}个热区</div>
                    </FormItem>
                </Form>

                <HotZoneEditor
                    {...this.props}
                    form={this.props.form}
                    wrapName={wrapName}
                    result={result}
                    visible={visible}
                    maxCount={20}
                    linkTypeMode={linkTypeMode}
                    imgUrl={backPic}
                    hotZoneList={hotZoneList}
                    onChange={onChange}
                    onClose={() => this.handleEditHotZone(false)}
                />
            </div>
        );
    }
}

export const HotZone = ConfigFormDecorator(Index);
